<i18n>
{
  "en": {
    "groupForecaster": "Forecast demand",
    "priceManager": "Dynamic Pricing",
    "menuManager": "Smart Menu",
    "outOfMenu": "Out-of-menu products"
  },
  "es": {
    "groupForecaster": "Previsión de demanda",
    "priceManager": "Dynamic Pricing",
    "menuManager": "Smart Menu",
    "outOfMenu": "Productos fuera de menu"
  }
}
</i18n>

<template>
  <div>
    <v-layout row wrap justify-space-around>
      <dynameat-management-button v-for="button in buttonList" :key="button.action"
                                  :action="button.action" :title="button.title" :icon="button.icon"
                                  :show-badge="button.showBadge" :visible="button.visible"
                                  :disabled="button.disabled" v-on="$listeners" class="btn danger"/>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import DynameatManagementButton from '@dynameat/components/DynameatManagementButton';

import { Components, MapActions, MapGetters } from '@core/helpers/decorators';

@Component
@Components({ DynameatManagementButton })
@MapActions(['addNotification'])
@MapGetters(['predictionPeriodList'])
export default class OptimizerPanel extends Vue {
  get buttonList() {
    return [
      {
        action: 'groupForecaster',
        disabled: false,
        title: this.$t('groupForecaster'),
        icon: 'mdi-poll',
      },
      {
        action: 'priceManager',
        disabled: false,
        title: this.$t('priceManager'),
        icon: 'mdi-tag',
      },
      {
        action: 'menuManager',
        disabled: false,
        title: this.$t('menuManager'),
        icon: 'mdi-silverware-fork-knife',
      }
    ];
  }
}

</script>
